import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';
import { mqMin } from '../../breakpoints';

const sharedAlternatingStyles: CustomTheme.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 's64',
  maxWidth: '920px',
  [mqMin.mobile]: {
    gap: 's40',
  },
  '.featureGridItem': {
    display: 'grid',
    gap: 's40',
    textAlign: 'center',
    '.textContainer': {
      maxWidth: '420px',
    },
    img: {
      margin: 0,
    },
    [mqMin.mobile]: {
      textAlign: 'unset',
      img: {
        width: '100%',
        maxWidth: '340px',
      },
    },
  },
};

const featureGridContainer: CustomTheme.VariantCSSKeys<ContainerVariantsType> = {
  default: {
    rowGap: 's80',
    [mqMin.tabletSmall]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
      columnGap: 's40',
    },
  },
  offset: {
    [mqMin.mobile]: {
      columnGap: 's80',
      '.featureGridItem': {
        '&:nth-of-type(3n+1), &:nth-of-type(3n+3)': {
          marginTop: 's40',
        },
      },
    },
  },
  variableHeightCards: {
    alignItems: 'start',
  },
  cards: {},
  resources: {
    textAlign: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    '.featureGridItem': {
      flex: '0 1 300px',
      marginTop: 's24',
    },
  },
  alternating: {
    ...sharedAlternatingStyles,
    '.featureGridItem': {
      [mqMin.tablet]: {
        '&:nth-of-type(odd)': {
          gridTemplateColumns: '2fr 3fr 1fr',
        },
        '&:nth-of-type(even)': {
          gridTemplateColumns: '1fr 3fr 2fr',
          justifyItems: 'end',
        },
      },
      [mqMin.mobile]: {
        '&:nth-of-type(odd)': {
          img: {
            gridColumn: 1,
            order: 1,
          },
          '.textContainer': {
            gridColumn: 2,
            order: 2,
          },
        },
        '&:nth-of-type(even)': {
          img: {
            gridColumn: 3,
            order: 2,
          },
          '.textContainer': {
            gridColumn: 2,
            order: 1,
          },
        },
      },
    },
  },
  alternatingReversed: {
    ...sharedAlternatingStyles,
    '.featureGridItem': {
      [mqMin.tablet]: {
        '&:nth-of-type(even)': {
          gridTemplateColumns: '2fr 3fr 1fr',
        },
        '&:nth-of-type(odd)': {
          gridTemplateColumns: '1fr 3fr 2fr',
          justifyItems: 'end',
        },
      },
      [mqMin.mobile]: {
        '&:nth-of-type(even)': {
          img: {
            gridColumn: 1,
            order: 1,
          },
          '.textContainer': {
            gridColumn: 2,
            order: 2,
          },
        },
        '&:nth-of-type(odd)': {
          img: {
            gridColumn: 3,
            order: 2,
          },
          '.textContainer': {
            gridColumn: 2,
            order: 1,
          },
        },
      },
    },
  },
};

const container: Product.VariantKeyModes<ContainerVariantsType> = {
  products: {
    chart: featureGridContainer,
    chartblog: featureGridContainer,
    co: featureGridContainer,
    edu: featureGridContainer,
    scale: featureGridContainer,
    spark: featureGridContainer,
  },
};

export type ContainerVariantsType =
  | 'default'
  | 'offset'
  | 'cards'
  | 'resources'
  | 'alternating'
  | 'alternatingReversed'
  | 'variableHeightCards';
export const containerVariants = Object.keys(featureGridContainer) as ContainerVariantsType[];

export default container;
